module.exports = __webpack_public_path__ + "static/screenshot3-68676f1219511c1c1a8c394c9de77aea.png";